<script setup lang="ts">
import { FilterBy, useEventListing, useTerms } from '~/api/drupal'
import { ParagraphEventListing } from '~/api/graphql/generated'
import { useI18n } from 'vue-i18n'

const props = defineProps<{
  entity: ParagraphEventListing
}>()

useNoCache()

const route = useRoute()
const { t } = useI18n()

const showFilter = props.entity.fieldShowFilter || false
const selectedEventTypes = (props.entity.fieldEventTypeTaxonomy || [])
  .map((item) => item?.entity?.tid?.toString())
  .filter((tid): tid is string => !!tid)
const selectedEventCategories = (props.entity.fieldEventCategory || [])
  .map((item) => item?.entity?.tid?.toString())
  .filter((tid): tid is string => !!tid)
const filterBy = props.entity.fieldFilterBy ? (props.entity.fieldFilterBy as FilterBy) : 'type'

const { terms: eventTypes } = await useTerms(['event_type'])
const { terms: eventCategories } = await useTerms(['event_category'])

const filter = reactive({
  type: route.query.type ? (route.query.type as string).split(',') : [],
  location: route.query.location ? (route.query.location as string).split(',') : ['1', '0'],
})

const selectedTaxonomies = { eventTypes: selectedEventTypes, eventCategories: selectedEventCategories }

const { years, page, pages, noResults, allUsedTypeIds } = await useEventListing(selectedTaxonomies, filter, filterBy)

const options = {
  ...(showFilter
    ? {
        type: (filterBy === 'type' ? eventTypes.value.event_type : eventCategories.value.event_category).filter(
          (term) => allUsedTypeIds.includes(term.id),
        ),
      }
    : {}),
  location: [
    {
      value: '1',
      label: t('event.list.filters.locationPhysical'),
    },
    {
      value: '0',
      label: t('event.list.filters.locationOnline'),
    },
  ],
}
</script>

<template>
  <Events
    v-model:filter="filter"
    v-model:page="page"
    :text="{
      title: props.entity.fieldTitle || '',
      location: t('event.conferenceList.filters.location'),
      noResults: t('event.conferenceList.noResults'),
    }"
    :options="options"
    :years="years"
    :pages="pages"
    :no-results="noResults"
    :show-filter="showFilter"
  />
</template>
<style scoped lang="scss"></style>
